if (!customElements.get('dynamic-checkout-label')) {
  class DynamicCheckoutLabel extends HTMLElement {
    connectedCallback() {
      this.customLabel = this.dataset.label?.trim();
      if (!this.customLabel) return;

      this.applyLabel();
      this.observer = new MutationObserver(() => this.applyLabel());
      this.observer.observe(this, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    applyLabel() {
      const button = this.querySelector('.shopify-payment-button__button--unbranded');
      if (button && button.textContent.trim() !== this.customLabel) {
        button.textContent = this.customLabel;
      }
    }
  }

  customElements.define('dynamic-checkout-label', DynamicCheckoutLabel);
}
